import * as React from 'react';
import TiptapEditor from './TiptapEditor';

interface MedicalHistoryEditorProps {
  initialValue?: string | null;
  loading: boolean;
  onChange: (value: string) => void;
  onBlur?: () => void;
}

/**
 * Rich-text editor for clinical "medical history" content (SHER-271).
 *
 * Now backed by the schema-based TipTap editor instead of the legacy
 * contentEditable HTMLEditor: it accepts the existing legacy HTML as
 * `initialValue` and emits clean, schema-constrained HTML — so the screen and
 * PDF renderers keep working while the unrenderable junk (font/span/style/o:p)
 * can no longer be produced. The previous "use HTMLEditor for everything"
 * branching was a no-op (both paths returned HTMLEditor) and has been removed.
 */
const MedicalHistoryEditor: React.FC<MedicalHistoryEditorProps> = ({
  initialValue,
  loading,
  onChange,
  onBlur,
}) => (
  <TiptapEditor
    initialValue={initialValue}
    loading={loading}
    onChange={onChange}
    onBlur={onBlur}
    format="html"
  />
);

export default MedicalHistoryEditor;
